import React from 'react';
import {
  BoxLogoutIcon,
  ButtonLabel,
  ButtonStyled,
  ContainerContent,
  ContainerDashboard,
  ContainerLogo,
  GridContainerVideo,
  ResetContainer,
  SubTitle,
  Title,
} from './dashboard.styled';
import Logo from '@components/Logo';
import { Box, Grid, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Reset } from '../../assets/icons/Reset.svg';
import Paths from '@/routes/paths';
import ReactPlayer from 'react-player';
import ProgressBar from '@atoms/ProgressBar';
import { ReactComponent as SoundOf } from '../../assets/icons/SoundOff.svg';
import { ReactComponent as SoundOn } from '../../assets/icons/SoundOnIcon.svg';
import { ReactComponent as LogoutIcon } from '../../assets/icons/Logout.svg';
import useCandidate from '@authentication/hooks/useCandidate';
import { useCandidateStore } from '@/store/candidate.store';
import { levels } from '@/utils/const';
import { DeleteFinalCvVideo, deleteImages } from '@services/uploadCvVideo';
import useCandidateId from '@/hooks/CandidateIdHook';

function DashboardCard() {
  const navigate = useNavigate();
  const [muted, setMuted] = React.useState(true);
  const { setLevels, updateActiveStatus } = useCandidateStore();

  const {
    setRecordChunksG,
    setPhotos,
    setVideo,
    setIsSplitPhotos,
    setCandidate,
    setVideoDuration,
  } = useCandidate();

  const videoRef = React.useRef<any>(null);
  const [url, setUrl] = React.useState('');
  const candidateId = useCandidateId();
  const [playVideo, setPlayVideo] = React.useState(true);
  const [resetProgressBar, setResetProgressBar] = React.useState(false);
  const handleGo = () => {
    navigate(Paths.FindProfilePage);
  };
  const handleOnPlayVideo = () => {
    setPlayVideo(true);
  };
  const handleReset = () => {
    setResetProgressBar(!resetProgressBar);
    const newUrl: string =
      'https://business-video.s3.eu-west-3.amazonaws.com/cv-video-example/cv.mp4' +
      '?' +
      String(Date.now());
    setUrl(newUrl);
  };

  React.useEffect(() => {
    localStorage.removeItem('showPhotos');

    setUrl(
      'https://business-video.s3.eu-west-3.amazonaws.com/cv-video-example/cv.mp4',
    );
  }, []);
  const handleLogout = () => {
    navigate('/logout');
  };
  const handleResetCandidateCvVideo = () => {
    deleteImages(candidateId);
    DeleteFinalCvVideo(candidateId);
    localStorage.removeItem('candidate_id');
    localStorage.removeItem('transcodingDone');
    localStorage.removeItem('generate_images');
    localStorage.removeItem('photoTacked');
  };
  React.useEffect(() => {
    setRecordChunksG([]);
    setVideo(undefined);
    setPhotos([]);
    setVideoDuration(0);
    setIsSplitPhotos(false);
    setCandidate(null);
    setLevels(levels);
    updateActiveStatus(1, true);
  }, []);

  React.useEffect(() => {
    if (candidateId) {
      handleResetCandidateCvVideo();
    }
  }, [candidateId]);

  return (
    <ContainerDashboard>
      <ContainerContent>
        <ContainerLogo>
          <Logo />
          <IconButton onClick={handleLogout}>
            <BoxLogoutIcon>
              <Box>
                <LogoutIcon color="#EDC2E2" />
              </Box>
            </BoxLogoutIcon>
          </IconButton>
        </ContainerLogo>

        <ContainerContent>
          <Grid
            container
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid item md={7} xs={8} sx={{ display: 'flex' }} gap="16px">
              <ProgressBar reset={resetProgressBar} />
            </Grid>
            <Grid item md={4}></Grid>
            <Grid item md={1}>
              <ResetContainer>
                <Reset key={1} onClick={handleReset} />
              </ResetContainer>
            </Grid>
          </Grid>
          <GridContainerVideo container>
            <Box
              sx={{
                position: 'relative',
              }}
            >
              <ReactPlayer
                ref={videoRef}
                muted={muted}
                onPlay={handleOnPlayVideo}
                playing={playVideo}
                url={url}
                loop
                width="100%"
                height="100%"
                config={{
                  file: {
                    attributes: {
                      preload: 'auto',
                    },
                  },
                }}
              />
              {playVideo && !muted ? (
                <IconButton
                  onClick={() => setMuted(!muted)}
                  sx={{ position: 'absolute', bottom: '30px' }}
                >
                  <SoundOn fontSize="large" />
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => setMuted(!muted)}
                  sx={{ position: 'absolute', bottom: '30px' }}
                >
                  <SoundOf fontSize="large" />
                </IconButton>
              )}
            </Box>
          </GridContainerVideo>

          <Grid
            container
            marginTop={2}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Grid item md={7}>
              <Box>
                <Title>Connectez-vous</Title>
                <SubTitle>
                  Saisissez et confirmez votre numéro de téléphone.
                </SubTitle>
              </Box>
            </Grid>
            <Grid item md={4}>
              <ButtonStyled onClick={handleGo}>
                <ButtonLabel>Créer mon CV Vidéo</ButtonLabel>
              </ButtonStyled>
            </Grid>
          </Grid>
        </ContainerContent>
      </ContainerContent>
    </ContainerDashboard>
  );
}

export default DashboardCard;
